// Telemetry validation -- iteration 061

import { z } from "zod";

export const telemetryEventSchema = z.object({
  type: z.enum(["page_view", "action", "perf", "error"]),
  page: z.string().min(1).max(200),
  timestamp: z.string(),
  action: z.string().max(200).optional(),
  value: z.string().max(500).optional(),
  duration_ms: z.number().int().nonnegative().optional(),
  metric: z.string().max(50).optional(),
  message: z.string().max(1000).optional(),
  status: z.number().int().optional(),
});

export const telemetryBatchSchema = z.object({
  events: z.array(telemetryEventSchema).min(1).max(100),
  client: z.object({
    platform: z.enum(["web", "android", "ios"]),
    version: z.string().min(1).max(50),
  }),
  session_id: z.string().min(1).max(100),
});

export type TelemetryBatchInput = z.infer<typeof telemetryBatchSchema>;
